import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import ListViewCpt from '@/components/list/ListViewCpt';
import PopSelect from '@/components/pop-select';
import { rqtPostRedemptionApplicationList } from '@/services/wms/redemption';
import { rqtPostFloatProductListForSelect } from '@/services/wms/product';
import cptCmn from '@/mixin/cpt-cmn';
export default {
  mixins: [cptCmn],
  components: {
    PageNavBackLayoutCpt,
    ListViewCpt,
    PopSelect
  },
  data() {
    return {
      btnLoading: false,
      searchForm: {
        customerName: undefined,
        productId: null,
        redemptionProgressType: null,
        redemptionStatus: null,
        redemptionType: null
      },
      listRequest: rqtPostRedemptionApplicationList,
      codeResItems: [{
        title: '赎回状态',
        dataIndex: 'redemptionStatus',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'redemptionStatus'
      }, {
        title: '赎回类型',
        dataIndex: 'redemptionType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'redemptionType'
      }, {
        title: '赎回进度',
        dataIndex: 'redemptionProgressType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'redemptionProgressType'
      }],
      showPopup: false,
      searchItems: [{
        title: '产品',
        type: 'dropdown',
        name: 'productId',
        request: rqtPostFloatProductListForSelect,
        keyName: 'id',
        valueName: 'productName',
        selectedOptions: []
      }, {
        title: '赎回类型',
        type: 'flatSelect',
        name: 'redemptionType',
        mutiSelect: false,
        options: [],
        selectedOptions: []
      }, {
        title: '赎回状态',
        type: 'flatSelect',
        name: 'redemptionStatus',
        mutiSelect: false,
        options: [],
        selectedOptions: []
      }, {
        title: '赎回进度',
        type: 'flatSelect',
        name: 'redemptionProgressType',
        mutiSelect: false,
        options: [],
        selectedOptions: []
      }, {
        title: '开放日',
        type: 'datePicker',
        name: 'productOpenDate',
        options: [],
        selectedOptions: []
      }]
    };
  },
  computed: {
    noCondition() {
      for (let selectItem of this.searchItems) {
        if (selectItem.selectedOptions.length > 0) {
          return false;
        }
      }
      return true;
    }
  },
  mounted() {
    this.initResCodeType(this.codeResItems).then(res => {
      for (let item of this.searchItems) {
        for (let codeItem of res) {
          if (item.name == codeItem.dataIndex) {
            item.options = codeItem.dataRes.map(e => {
              return {
                key: e.code,
                value: e.codeName
              };
            });
            break;
          }
        }
      }
    });
  },
  methods: {
    onSearch() {
      this.btnLoading = true;
      this.$refs['ListViewCpt'].initListData();
    },
    onListDataChange() {
      if (this.btnLoading) {
        this.btnLoading = false;
      }
    },
    showCondition() {
      this.showPopup = true;
    },
    handlePopSelectConfirm(searchItems) {
      for (let searchItem of searchItems) {
        if (searchItem.type == 'datePicker') {
          this.searchForm[searchItem.name + 'Start'] = searchItem.selectedOptions[0];
          this.searchForm[searchItem.name + 'End'] = searchItem.selectedOptions[1];
        } else {
          this.searchForm[searchItem.name] = searchItem.selectedOptions[0];
        }
      }
      this.$refs['ListViewCpt'].initListData();
      this.showPopup = false;
    }
  }
};